module.exports = __webpack_public_path__ + "media/promo/hochland/images/l2-69f3dad85ec0b0b93f6c0030962c1029.png";